import client from "@/client/publicApiClient.ts";
import type { ResponseConfig } from "@/client/publicApiClient.ts";
import type { GetAllClientInvitationsQueryResponse, GetAllClientInvitationsPathParams, GetAllClientInvitationsQueryParams } from "../types/GetAllClientInvitations";

 /**
 * @description Gets a list of all invitations for a given client and the state of the
respective invite tokens.
 * @summary Get all
 * @link /api/clients/:clientCode/invitations
 */
export async function getAllClientInvitations(clientCode: GetAllClientInvitationsPathParams["clientCode"], params?: GetAllClientInvitationsQueryParams, options: Partial<Parameters<typeof client>[0]> = {}): Promise<ResponseConfig<GetAllClientInvitationsQueryResponse>["data"]> {
    const res = await client<GetAllClientInvitationsQueryResponse>({ method: "get", url: `/api/clients/${clientCode}/invitations`, params, ...options });
    return res.data;
}